import { FC } from 'react';

interface IProps {
  isAdded: boolean;
  isChanged: boolean;
}

// The edit-session pill next to a policy or rule name: green "new" wins over amber "changed".
const ChangeMarker: FC<IProps> = ({ isAdded, isChanged }) => {
  if (isAdded) {
    return (
      <span className='routing-policy-marker routing-policy-marker--new' title='Added in this edit session'>
        new
      </span>
    );
  }
  if (isChanged) {
    return (
      <span
        className='routing-policy-marker routing-policy-marker--changed'
        title='Changed in this edit session'
      >
        changed
      </span>
    );
  }
  return null;
};

export default ChangeMarker;
